export default function TryPage() {
  return <div>Try Page</div>;
}
